<template>
<div>

  <b-sidebar
    id="sidebar-right"
    ref="filterSidebar"
    right
    title="ფილტრები"
    text-variant="body"
    class="theme-bg-white e-mtavr-17 e-zindex-1"
    bg-variant="white"
    shadow
    backdrop
    :backdrop-variant="variant"
    width="550px"
    @change="toggleBodyScrollbar"
    >
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 h-100">
        <perfect-scrollbar :options="{ wheelPropagation: true, suppressScrollX: true}" class="mb-4" style="height: 100%">
        <form v-if="filterType === 'requests'">
            <!-- <h5 class="e-mtavr-17 text-muted">სტატუსის ფილტრები</h5>
            <hr> -->
            <div class="row">
            <div class="col-mg-6 col-lg-6">
            <b-form-group label="სქრინინგ სტატუსი" class="e-nusx-6 text-muted" label-size="sm">
                <b-select size="sm" v-model="filterObject.columnFilters.ScrStatus">
                    <option value=""></option>
                    <option value="0">არცერთი დამთხვევა</option>
                    <option value="x">საყურადღებო</option>
                </b-select>
            </b-form-group>
            </div>
            <div class="col-mg-6 col-lg-6">
            <b-form-group label="მოთოვნის სტატუსი" class="e-nusx-6 text-muted" label-size="sm">
                <b-select size="sm" v-model="filterObject.columnFilters.statusText">
                    <option value=""></option>
                    <option value="დაუმუშავებელი">დაუმუშავებელი</option>
                    <option value="მუშავდება">მუშავდება</option>
                    <option value="დადასტურებული">დადასტურებული</option>
                    <option value="დაბლოკილი">დაბლოკილი</option>
                </b-select>
            </b-form-group>
            </div>
            <div class="col-mg-6 col-lg-6">
            <b-form-group label="დამუშავების შედეგი" class="e-nusx-6 text-muted" label-size="sm">
                <b-select size="sm" v-model="filterObject.columnFilters.Decision">
                    <option value=""></option>
                    <option v-for="dc in decisionTypes" :key="dc.$index">{{dc.type}}</option>
                </b-select>
            </b-form-group>
            </div>
            </div>
            <!-- <h5 class="e-mtavr-17 text-muted">საძიებო პარამეტრების ფილტრი</h5>
            <hr> -->
            <div class="row">
                <div class="col-md-6 col-lg-6">
                    <b-form-group label="დაბადების თარიღი" class="e-nusx-6 text-muted" label-size="sm">
            <datepicker
                    :bootstrapStyling="true"
                    id="bDate"
                    :language="locale"
                    :monday-first="true"
                    placeholder="აირჩიე თარიღი"
                    :calendar-button="true"
                    calendar-button-icon="far fa-calendar-alt fa-xs"
                    input-class="form-control form-control-sm"
                    v-model="filterObject.columnFilters.brthDate"
                    :clear-button="true"
                    clear-button-icon="fas fa-times fa-xs"
                  />
            </b-form-group>
                </div>
                <div class="col-md-6 col-lg-6">
                      <b-form-group label="დამუშავების %" class="e-nusx-6 text-muted" label-size="sm">
                <b-input size="sm" v-model="filterObject.columnFilters.matchPercent" type="number"/>
            </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-lg-6">
                    <b-form-group label="სახელი / იურ. დასახელება" class="e-nusx-6 text-muted" label-size="sm">
                <b-input size="sm" v-model="filterObject.columnFilters.firstName"/>
            </b-form-group>
                </div>
                <div class="col-md-6 col-lg-6">
                    <b-form-group label="გვარი" class="e-nusx-6 text-muted" label-size="sm">
                <b-input size="sm" v-model="filterObject.columnFilters.lastName"/>
            </b-form-group>
                </div>
            </div>
            <!-- <h5 class="e-mtavr-17 text-muted">საიდენტიფიკაციო მონაცემების ფილტრი</h5>
            <hr/> -->
            <div class="row">
                <div class="col-md-6 col-lg-6">
<b-form-group label="მისამართი" class="e-nusx-6 text-muted" label-size="sm">
                <b-input size="sm" v-model="filterObject.columnFilters.FullAddress"/>
            </b-form-group>
                </div>
                <div class="col-md-6 col-lg-6">
                    <b-form-group label="რეზიდენტობა" class="e-nusx-6 text-muted" label-size="sm">
                <b-input size="sm" autocomplete="off" v-model="filterObject.columnFilters.countryISO" id="filtercountryinput" @input="filterfilterCountries()" @focus="filterfilterCountries(), filtershowPop = true"/>
                <b-popover id="filterprimaryPopover-container" container="filterprimaryPopover-container" target="filtercountryinput" custom-class="e-popover-danger e-z-index-8x9" placement="bottom" triggers="manual" :show.sync="filtershowPop">
                     <ul class="e-liststyle-none e-eng-font e-listinpopover">
                      <li v-for="fltrcntry in filterfilteredCountriesList" :key="fltrcntry.$index" @click="filtersetCountry(fltrcntry)" class="g-cursor-pointer">{{fltrcntry.countryName}}</li>
                    </ul>
                  </b-popover>
            </b-form-group>
                </div>
                <div class="col-md-6 col-lg-6">
<b-form-group label="იდენტიფიკატორი" class="e-nusx-6 text-muted" label-size="sm">
                <b-input size="sm" v-model="filterObject.columnFilters.personalN"/>
            </b-form-group>
                </div>
            </div>
            <!-- <h5 class="e-mtavr-17 text-muted">სხვა ფილტრი</h5>
            <hr/> -->
             <div class="row">
                <div class="col-md-6 col-lg-6">
<b-form-group label="მოთხოვნის დრო" class="e-nusx-6 text-muted" label-size="sm">
                <datepicker
                id="reqDate"
                    :bootstrapStyling="true"
                    :language="locale"
                    :monday-first="true"
                    placeholder="აირჩიე თარიღი"
                    :calendar-button="true"
                    calendar-button-icon="far fa-calendar-alt fa-xs"
                    input-class="form-control form-control-sm"
                    :clear-button="true"
                    clear-button-icon="fas fa-times fa-xs"
                    v-model="filterObject.columnFilters.reqDate"
                  />
            </b-form-group>
                </div>
                <div class="col-md-6 col-lg-6">
                    <b-form-group label="მომხმარებელი" class="e-nusx-6 text-muted" label-size="sm">
                <b-select size="sm" v-model="filterObject.columnFilters.id">
                    <option value="0"></option>
                    <option v-for="u in activeUsers" :key="u.$index" :value="u.id">{{u.firstName}} {{u.lastName}}</option>
                </b-select>
            </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <hr>
                    <button class="btn btn-secondary btn-sm" @click="clearFilter">გასუფთავება</button>
                    <button class="btn btn-primary btn-sm" @click="FilterData" type="button">გაფილტვრა</button>
                </div>
            </div>
        </form>
        <form v-if="filterType === 'clients'">
          <!-- <h5 class="e-mtavr-17 text-muted">სტატუსის ფილტრები</h5>
            <hr> -->
            <div class="row">
            <div class="col-mg-6 col-lg-6">
            <b-form-group label="სქრინინგ სტატუსი" class="e-nusx-6 text-muted" label-size="sm">
                <b-select size="sm" v-model="filterObject.columnFilters.ClReq_scrStatus">
                    <option value=""></option>
                    <option value="0">არცერთი დამთხვევა</option>
                    <option value="x">საყურადღებო</option>
                </b-select>
            </b-form-group>
            </div>
            <div class="col-mg-6 col-lg-6">
            <b-form-group label="სამართლებრივი ფორმა" class="e-nusx-6 text-muted" label-size="sm">
                <b-select size="sm" v-model="filterObject.columnFilters.ClReq_legalForm">
                    <option value=""></option>
                    <option value="1">ფიზიკური პირი</option>
                    <option value="2">იურიდიული პირი</option>
                </b-select>
            </b-form-group>
            </div>
            <div class="col-mg-6 col-lg-6">
            <b-form-group label="დამუშავების შედეგი" class="e-nusx-6 text-muted" label-size="sm">
                <b-select size="sm" v-model="filterObject.columnFilters.ClReq_Decision">
                    <option value=""></option>
                    <option v-for="dc in decisionTypes" :key="dc.$index">{{dc.type}}</option>
                </b-select>
            </b-form-group>
            </div>
            </div>
            <!-- <h5 class="e-mtavr-17 text-muted">საძიებო პარამეტრების ფილტრი</h5>
            <hr> -->
            <div class="row">
                <div class="col-md-6 col-lg-6">
                    <b-form-group label="სახელი / იურ. დასახელება" class="e-nusx-6 text-muted" label-size="sm">
                <b-input size="sm" v-model="filterObject.columnFilters.ClReq_firstName"/>
            </b-form-group>
                </div>
                <div class="col-md-6 col-lg-6">
                    <b-form-group label="გვარი" class="e-nusx-6 text-muted" label-size="sm">
                <b-input size="sm" v-model="filterObject.columnFilters.ClReq_lastName"/>
            </b-form-group>
                </div>
                  <div class="col-md-6 col-lg-6">
                    <b-form-group label="პირადი N" class="e-nusx-6 text-muted" label-size="sm">
                <b-input size="sm" v-model="filterObject.columnFilters.ClReq_personalN" type="text"/>
                </b-form-group>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <b-form-group label="პირადობის მოწმობის N" class="e-nusx-6 text-muted" label-size="sm">
                <b-input size="sm" v-model="filterObject.columnFilters.ClReq_documentN" type="text"/>
                </b-form-group>
                </div>
                <div class="col-md-6 col-lg-6">
                    <b-form-group label="დაბადების თარიღი" class="e-nusx-6 text-muted" label-size="sm">
            <datepicker
                    :bootstrapStyling="true"
                    :language="locale"
                    :monday-first="true"
                    placeholder="აირჩიე თარიღი"
                    :calendar-button="true"
                    calendar-button-icon="far fa-calendar-alt fa-xs"
                    input-class="form-control form-control-sm"
                    v-model="filterObject.columnFilters.ClReq_brthdate"
                    :clear-button="true"
                    clear-button-icon="fas fa-times fa-xs"
                  />
            </b-form-group>
                </div>
                <div class="col-md-6 col-lg-6">
                    <b-form-group label="რეზიდენტობა" class="e-nusx-6 text-muted" label-size="sm">
                <b-input size="sm" autocomplete="off" v-model="filterObject.columnFilters.countryISO" id="filtercountryinput" @input="filterfilterCountries()" @focus="filterfilterCountries(), filtershowPop = true"/>
                <b-popover id="filterprimaryPopover-container" container="filterprimaryPopover-container" target="filtercountryinput" custom-class="e-popover-danger e-z-index-8x9" placement="bottom" triggers="manual" :show.sync="filtershowPop">
                     <ul class="e-liststyle-none e-eng-font e-listinpopover">
                      <li v-for="fltrcntry in filterfilteredCountriesList" :key="fltrcntry.$index" @click="filtersetCountry(fltrcntry)" class="g-cursor-pointer">{{fltrcntry.countryName}}</li>
                    </ul>
                  </b-popover>
            </b-form-group>
                </div>
            </div>
            <!-- <h5 class="e-mtavr-17 text-muted">სხვა ფილტრი</h5>
            <hr/> -->
             <div class="row">
                <div class="col-md-6 col-lg-6">
<b-form-group label="მოთხოვნის დრო" class="e-nusx-6 text-muted" label-size="sm">
                <datepicker
                    :bootstrapStyling="true"
                    id="requestDate"
                    :language="locale"
                    :monday-first="true"
                    placeholder="აირჩიე თარიღი"
                    :calendar-button="true"
                    calendar-button-icon="far fa-calendar-alt fa-xs"
                    input-class="form-control form-control-sm"
                    :clear-button="true"
                    clear-button-icon="fas fa-times fa-xs"
                    v-model="filterObject.columnFilters.ClReq_reqDate"
                  />
            </b-form-group>
                </div>
                <div class="col-md-6 col-lg-6">
                    <b-form-group label="მომხმარებელი" class="e-nusx-6 text-muted" label-size="sm">
                <b-select size="sm" v-model="filterObject.columnFilters.ClReq_userid">
                    <option value="0"></option>
                    <option v-for="u in activeUsers" :key="u.$index" :value="u.id">{{u.firstName}} {{u.lastName}}</option>
                </b-select>
            </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <hr>
                    <button class="btn btn-secondary btn-sm" @click="clearFilter">გასუფთავება</button>
                    <button class="btn btn-primary btn-sm" @click="FilterData" type="button">გაფილტვრა</button>
                </div>
            </div>
        </form>
        </perfect-scrollbar>
        </div>
      </b-sidebar>

</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { ge } from 'vuejs-datepicker/dist/locale'
import PerfectScrollbar from '@/vendor/libs/perfect-scrollbar/PerfectScrollbar'
import moment from 'moment'
export default {
  props: ['filterType'],
  components: {
    Datepicker,
    PerfectScrollbar
  },
  data () {
    return {
      filtershowPop: false,
      filterfullCountryList: [],
      filterfilteredCountriesList: [],
      editing: false,
      decisionTypes: this.$store.getters.GetDecisionTypes,
      locale: ge,
      variant: 'dark',
      variants: [
        'transparent',
        'white',
        'light',
        'dark',
        'primary',
        'secondary',
        'success',
        'danger',
        'warning',
        'info'
      ],
      filterObject: {
        columnFilters: {
          countryISO: ''
        }
      },
      activeUsers: []
    }
  },
  methods: {
    toggleBodyScrollbar (visible) {
      const body = document.getElementsByTagName('body')[0]
      if (visible) { body.classList.add('overflow-hidden') } else { body.classList.remove('overflow-hidden') }
    },
    FilterData () {
      if (this.filterObject.columnFilters.brthDate) {
        this.filterObject.columnFilters.brthDate = moment(this.filterObject.columnFilters.brthDate).format('YYYY-MM-DD')
      }
      if (this.filterObject.columnFilters.ClReq_brthdate) {
        this.filterObject.columnFilters.ClReq_brthdate = moment(this.filterObject.columnFilters.ClReq_brthdate).format('YYYY-MM-DD')
      }
      if (this.filterType === 'clients') {
        this.filterObject.columnFilters.ClReq_countryISO = this.filterObject.columnFilters.countryISO
        this.filterObject.columnFilters.countryISO = ''
        // this.filterObject.columnFilters.Nationality = ''
      }
      this.filterObject.columnFilters.countryISO = this.filterObject.columnFilters.CountryCodeTmp
      this.$emit('fromFilter', this.filterObject)
      this.$refs.filterSidebar.hide()
    },
    filterfilterCountries () {
      // debugger // eslint-disable-line
      if (this.filterfilteredCountriesList.length === 0) {
        this.showPop = false
        this.filterfilteredCountriesList = this.filterfullCountryList
        this.CountryNotFound = true
      } else {
        this.CountryNotFound = false
      }
      // console.log(this.fullCountryList.filter((cntry) => {
      //   // debugger // eslint-disable-line
      //   this.showPop = true
      //   return cntry.twoCharCountryCode
      //     .toLowerCase()
      //     .startsWith(this.newReqItem.countryISO.toLowerCase())
      // }))
      this.filterfilteredCountriesList = this.filterfullCountryList.filter((cntry) => {
        // debugger // eslint-disable-line
        // console.log('cntry:' + cntry.countryName)
        this.showPop = true
        return cntry.countryName
          .toLowerCase()
          .startsWith(this.filterObject.columnFilters.countryISO.toLowerCase())
      })
    },
    filtersetCountry (data) {
      this.filterObject.columnFilters.countryISO = data.countryName
      this.filterObject.columnFilters.country = data.countryName
      this.filterObject.columnFilters.CountryCodeTmp = data.twoCharCountryCode
      this.showPop = false
    },
    // filterfilterCountries () {
    // // debugger // eslint-disable-line
    //   if (this.filterfilteredCountriesList.length === 0) {
    //     this.filterfilteredCountriesList = this.filterfullCountryList
    //   }
    //   this.filterfilteredCountriesList = this.filterfullCountryList.filter(cntry => {
    //     this.filtershowPop = true
    //     return cntry.twoCharCountryCode.toLowerCase().startsWith(this.filterObject.columnFilters.countryISO.toLowerCase())
    //   })
    // },
    // filtersetCountry (data) {
    //   this.filterObject.columnFilters.countryISO = data.twoCharCountryCode
    //   this.filterObject.columnFilters.Nationality = data.countryName
    //   this.filtershowPop = false
    // },
    clearFilter () {
      this.filterObject.columnFilters = {}
      this.$emit('fromFilter', this.filterObject)
    }
  },
  mounted () {
    this.filterfullCountryList = this.$store.getters.GetCountriesList
    this.activeUsers = this.$store.getters.GetActiveUsersList
  }
}
</script>

<style>

</style>
